import Vue    from 'vue'
import router from './router'
import store  from './store'

import Index  from './Index.vue'

import 'current-device'
import 'reset-css'
import '@/assets/styles/abstracts/_utilities.scss'
import '@/assets/styles/base/_fonts.scss'
import '@/assets/styles/common.scss'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill();

import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { 
    id: 'G-TX60ZZNC2S',
    params: {
      send_page_view: false
    }
  }
});

Vue.prototype.$trackPage = function(pageName) {
  this.$gtag.pageview({
    page_path: '/' + pageName,
  })
  console.log(`Pageview Tracked: /${pageName}`);
}

Vue.prototype.$trackEvent = function(category, action, label, callback) {
  // if (this.$gtag) {
  //   this.$gtag.event(action, {
  //     'event_category': category,
  //     'event_label': label,
  //     'event_callback': callback,
  //   })
  // } else {
  //   if (callback) callback();
  // }
  this.$gtag.event(action, {
    'event_category': category,
    'event_label': label,
  })
  if (callback) {
    setTimeout(() => {
      callback();
    }, 500)
  }
  console.log(`Event Tracked: ${action}, ${category}, ${label}`);
}

import Toast from 'vue-toastification'
// import 'vue-toastification/dist/index.css'
import '@/assets/styles/vendors/vue-toastification.scss'
Vue.use(Toast, {
  transition: 'Vue-Toastification__fade',
  timeout: 2000,
  maxToasts: 3,
  position: 'top-center',
  transitionDuration: 500,
  hideProgressBar: true,
});

// import VueClipboard from 'vue-clipboard2'
// Vue.use(VueClipboard)

import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(Index),
  mounted() {
    // document.dispatchEvent(new Event('render-event'));
  },
}).$mount('#app')
